import React from 'react';

const StopIcon = () => (
    <svg viewBox="0 0 13 15" aria-hidden="true">
        <rect
            id="Rectangle"
            x="0"
            y="1"
            width="13"
            height="13"
            rx="2"
        />
    </svg>
);

export default StopIcon;
